/**
 * Portal Manta · MacroTab
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, fmtBRL } from '../../globals.js';
import { THl, TH, TDl, TD } from '../../app-globals.js';

function MacroTab({lote}){
  const mp=lote.dados_manta?.macro_planejamento||{};
  const anos=mp.anos||[];
  const itens=mp.itens||[];
  if(!itens.length) return <div style={{padding:24,color:V.g4,fontSize:11}}>Sem dados de macro planejamento</div>;
  return(<div style={{padding:'12px 16px'}}>
    <div style={{marginBottom:10}}>
      <div style={{fontSize:12.5,fontWeight:700,color:V.br2}}>Macro Planejamento</div>
      <div style={{fontSize:10.5,color:V.g5,marginTop:2}}>Distribuição anual de investimentos por tipologia</div>
    </div>
    <div style={{overflowX:'auto',border:`1px solid ${V.g2}`,borderRadius:10}}>
      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead><tr>
          <th style={{...THl,width:80}}>Item</th>
          <th style={THl}>Descrição</th>
          {anos.map(a=>(<th key={a} style={TH}>Ano {a}</th>))}
          <th style={{...TH,color:V.br}}>Total</th>
        </tr></thead>
        <tbody>{itens.map((it,i)=>{
          const total=it.por_ano.reduce((s,v)=>s+(v||0),0);
          return(<tr key={i} style={{borderBottom:`1px solid ${V.g1}`,background:i%2===0?'#fff':V.g0}}>
            <td style={{...TDl,fontFamily:'monospace',fontSize:9.5,color:V.g4}}>{it.codigo}</td>
            <td style={{...TDl,fontSize:10.5,color:V.g7}}>{it.descricao}</td>
            {anos.map((_,yi)=>(<td key={yi} style={{...TD,color:V.g7}}>{it.por_ano[yi]!=null?fmtBRL(it.por_ano[yi]):'—'}</td>))}
            <td style={{...TD,fontWeight:700,color:V.or}}>{total>0?fmtBRL(total):'—'}</td>
          </tr>);
        })}</tbody>
      </table>
    </div>
  </div>);}

export { MacroTab };
export default MacroTab;
